import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsConversationsRoute} from './conversations-route'
import {SplitPageLayout} from '@primer/react'
import {RailsPartial} from '@github-ui/rails-partial'
import {useAlive} from '@github-ui/use-alive'

export function ConversationsEntrypoint() {
  const {
    data: {aliveChannel},
  } = useRouteQuery(pullRequestsConversationsRoute, 'mainQuery')
  const {data: mainContent, refetch: refetchMainContent} = useRouteQuery(
    pullRequestsConversationsRoute,
    'pullRequestsConversationsRoute.Conversation',
  )
  const {data: sidebarContent, refetch: refetchSidebarContent} = useRouteQuery(
    pullRequestsConversationsRoute,
    'pullRequestsConversationsRoute.Sidebar',
  )

  useAlive(aliveChannel, () => {
    refetchMainContent()
    refetchSidebarContent()
  })

  return (
    <>
      <SplitPageLayout className="width-full">
        <SplitPageLayout.Content padding="condensed">
          <RailsPartial html={mainContent} />
        </SplitPageLayout.Content>
        <SplitPageLayout.Pane position="end" sticky={false} divider="none" padding="condensed">
          <RailsPartial html={sidebarContent} />
        </SplitPageLayout.Pane>
      </SplitPageLayout>
      {/* Needed for rails and not worth the effort of making them partials */}
      <div hidden>
        <span className="js-add-to-batch-enabled">
          Add this suggestion to a batch that can be applied as a single commit.
        </span>
        <span className="js-unchanged-suggestion">
          This suggestion is invalid because no changes were made to the code.
        </span>
        <span className="js-closed-pull">Suggestions cannot be applied while the pull request is closed.</span>
        <span className="js-viewing-subset-changes">
          Suggestions cannot be applied while viewing a subset of changes.
        </span>
        <span className="js-one-suggestion-per-line">Only one suggestion per line can be applied in a batch.</span>
        <span className="js-reenable-add-to-batch">
          Add this suggestion to a batch that can be applied as a single commit.
        </span>
        <span className="js-validation-on-left-blob">Applying suggestions on deleted lines is not supported.</span>
        <span className="js-validation-on-right-blob">
          You must change the existing code in this line in order to create a valid suggestion.
        </span>
        <span className="js-outdated-comment">Outdated suggestions cannot be applied.</span>
        <span className="js-resolved-thread">This suggestion has been applied or marked resolved.</span>
        <span className="js-pending-review">Suggestions cannot be applied from pending reviews.</span>
        <span className="js-is-multiline">Suggestions cannot be applied on multi-line comments.</span>
        <span className="js-in-merge-queue">
          Suggestions cannot be applied while the pull request is queued to merge.
        </span>
        <span className="js-head-oid-not-loaded">Suggestion cannot be applied right now. Please check back later.</span>
        <div
          className="form-group errored m-0 error js-suggested-changes-inline-validation-template d-flex"
          style={{cursor: 'default'}}
        >
          <span
            className="js-suggested-changes-inline-error-message position-relative error m-0"
            style={{maxWidth: 'inherit'}}
          />
        </div>
      </div>
    </>
  )
}

try{ ConversationsEntrypoint.displayName ||= 'ConversationsEntrypoint' } catch {}